import axios from "axios";
const PRMOCION_API_URL = "http://localhost:8082/acumulacion/mf/promociones";
//const PRMOCION_API_URL = 'http://192.168.236.242:8080/acumulacion/mf/promociones'
class PromocionDataService {
  getAll() {
    return axios.get(PRMOCION_API_URL + "/all");
  }
  save(promocion) {
    return axios.post(PRMOCION_API_URL + "/save", promocion);
  }
  getExists(codigoPromocion) {
    return axios.get(PRMOCION_API_URL + "/exists/" + codigoPromocion);
  }
  getExistsName(nombrePromocion) {
    return axios.get(PRMOCION_API_URL + "/existsName/" + nombrePromocion);
  }
  getValCondNoAcumulable(grupoCondciones,tipoMF){
    console.log("Validando");
    //console.log(grupoCondciones);
    //let grupos=[];
    let condiciones=[];
    //grupos = grupoCondciones;

    for(let i=0; i<grupoCondciones.length; i++){
      condiciones = grupoCondciones[i].condiciones;
      for(let j=0; j<condiciones.length; j++){
        if(condiciones[j].tipo == 'productoscombinados'){
          if(tipoMF == 'Tratamiento Completo')
            grupoCondciones[i].condiciones[j].acumulable=false;
          if(tipoMF == 'Medicación Frecuente')
            grupoCondciones[i].condiciones[j].acumulable=true;
        } 

      }
    }
    console.log(grupoCondciones);
    return grupoCondciones;
  }
}
export default new PromocionDataService();
